var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"keyboard-wrap"},[_vm._l((_vm.model.keyboard_setting_infos),function(item,index){return _c('div',{key:index + '-' + Math.random(),class:_vm.getClass(item),style:({
        left: item.x_posi + 40 + 'px',
        top: item.y_posi + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        'line-height': item.height + 'px',
      })},[_c('span',[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])}),_vm._l((_vm.model.mouse_setting_infos),function(item,index){return _c('div',{key:index + 100 + '-' + Math.random(),class:_vm.getClass(item),style:({ left: item.x_posi + 40 + 'px', top: item.y_posi + 'px', width: item.width + 'px', height: item.height + 'px' })})}),_vm._l((_vm.model.handle_setting_infos),function(item,index){return _c('div',{key:index + 1000 + '-' + Math.random(),staticClass:"keyboard-direction",style:({
        left: item.x_posi + 40 + 'px',
        top: item.y_posi + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        'line-height': item.height + 'px',
      })},[_c('span',[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])}),_vm._l((_vm.model.direction_setting_infos),function(item,index){return _c('div',{key:index + 1000 + '-' + Math.random(),staticClass:"keyboard-arrow",style:({
        left: item.x_posi + 40 + 'px',
        top: item.y_posi + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        'line-height': item.height + 'px',
      })},[_c('span',[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])}),_vm._l((_vm.model.key_setting_infos),function(item,index){return _c('div',{key:index + 1000 + '-' + Math.random(),class:_vm.getClass(item),style:({
        left: item.x_posi + 40 + 'px',
        top: item.y_posi + 'px',
        width: item.width + 'px',
        height: item.height + 'px',
        'line-height': item.height + 'px',
      })},[_c('span',[_vm._v("\n        "+_vm._s(item.text)+"\n      ")])])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }